

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
@Component
export default class Notes extends Vue {
  // props
  @Prop(String) readonly fieldName!: string;
  @Prop(String) readonly placeholder!: string;
  @Prop(String) classPrefix?: string;
  @Prop(String) readonly value!: string;

  mounted() {
    const input = document.querySelector("input") as HTMLInputElement;
    input.addEventListener("blur", function() {
      window.scrollTo(0,500)
    });
  }
  // methods
  onValueChanged(value: string) {
    this.$emit("update:value", value);
  }
}
